export default __webpack_public_path__ + "static/media/comerce-logo-blue.47e28c10.webp";